module.exports = __webpack_public_path__ + "static/img/6.d6b9713.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/6.jpg
// module id = q3wp
// module chunks = 2